import { ElementRef, EventEmitter, OnInit,HostListener,ViewChild } from '@angular/core';
import { Component, Input,Output } from '@angular/core';
import { Category } from '../../models/Category';
import { faTurnUp } from '@fortawesome/free-solid-svg-icons';
import { MatSelect } from '@angular/material/select';

@Component({
  selector: 'app-category-select', 
  templateUrl: './category-select.component.html',
  styleUrl: './category-select.component.css'
})
export class CategorySelectComponent implements OnInit {
  @ViewChild('CatSelect') mySelect: MatSelect;
  @Input() IsRoot: boolean;
  @Input() cats: Category[];
  @Output() CategorySelected = new EventEmitter<number>();  
  @Input() SelectedCategory: number;
  InternalCategories: Category[];


  faTurnUp = faTurnUp;
  public constructor(private elementRef:ElementRef) {

  }



  public ngOnInit() {
    //Need to add "Root" category
    this.InternalCategories = [];
    if (this.cats != undefined) {
      var tempCats = this.cats.filter(x => x.ParentID == null);
      for (var i = 0; i < tempCats.length; i++) {
        if (this.IsRoot && i == 0) {
          var rootCat = new Category();
          rootCat.Name = "Root";
          rootCat.CategoryID = -1;
          rootCat.Children = [];
          rootCat.NestLevel = 0;
          this.InternalCategories.push(rootCat);
        }
        
        this.InternalCategories.push(...this.GetChildren(tempCats[i],0));
      }
      
    }
    
  }

  GetChildren(cat: Category, nestLevel:number): Category[] {
    var retList = [];
    cat.NestLevel = nestLevel;
    retList.push(cat);
    if (cat.Children != null) {
      if (cat.Children.length > 0) {
        cat.Children.forEach(x => {
          x.NestLevel = nestLevel;
          retList.push(...this.GetChildren(x, nestLevel + 1));
        });
      }
    }
    return retList;
  }

  NestedSelectionChange(cat:Category) {
    const event: CustomEvent = new CustomEvent('CategorySelectedEvent', {
      bubbles: true,
      detail: cat.CategoryID
    });
    this.mySelect.close();
    this.elementRef.nativeElement.dispatchEvent(event);
  }

  RootSelectionChange(event:any) {
    //debugger;
    //this.CategorySelected.emit(this.SelectedCategory);
    const custEvent: CustomEvent = new CustomEvent('CategorySelectedEvent', {
      bubbles: true,
      detail: this.SelectedCategory
    });
    this.elementRef.nativeElement.dispatchEvent(custEvent);
  }


  public HasChildren(cat:Category): boolean
  {
    if (cat != null) {
      if (cat.Children == null) {
        return false;
      }
      else if (cat.Children.length == 0) {
        return false;
      }
      else {
        return true;
      }

    } else {
      return false;
    }
  
  }
}
